import React from 'react';

export default function MenuItemSeparator() {
  return (
    <li id="kt-menu__separator" className="kt-menu__separator">
      <span/>
    </li>
  );
}
